
import { Options, Vue } from 'vue-class-component';
  import TheFooterTop from './TheFooterTop.vue';
  import TheFooterBottom from './TheFooterBottom.vue';
  @Options({
    components: {TheFooterBottom, TheFooterTop}
  })
  export default class TheFooter extends Vue {
  }
